import { API_BASE_URL } from '../config';
// #
class InscricaoService {
    constructor(){
        this.state = {
            

            url: `${API_BASE_URL}/core/inscricoes/`,
            url8: `${API_BASE_URL}/core/inscricoes/efetiva_inscicao/`,
            url3: `${API_BASE_URL}/core/inscricoes/per_corrida/`,
            url4: `${API_BASE_URL}/core/inscricoes/per_corrida/count/`,
            url5: `${API_BASE_URL}/core/inscricoes/per_corrida/meios_pagamento/count/`,
            url6: `${API_BASE_URL}/core/inscricoes/count/corridas_user/`,
            url7: `${API_BASE_URL}/core/inscricoes/`,
            url2: `${API_BASE_URL}/core/fin/preferences/`,
            url_metrica: `${API_BASE_URL}/core/metrica_corredor/`,
            url_metricas: `${API_BASE_URL}/core/metricas_corredor/`,
            url_incricao_usuario_vigente: `${API_BASE_URL}/core/inscricoes/abertas/`,
            url_incricao_usuario_finalizada: `${API_BASE_URL}/core/inscricoes/finalizadas/`,
            url_incricao_usuario_pendente: `${API_BASE_URL}/core/inscricoes/pendentes/`,
            url_checkout_cartao: `${API_BASE_URL}/core/fin/checkout/cartao/`,
            url_checkout_pix: `${API_BASE_URL}/core/fin/checkout/pix/`,
            url_checkout_status: `${API_BASE_URL}/core/fin/checkout/status/`,
            url_orders_corrida: `${API_BASE_URL}/core/fin/orders/corrida/`,
            url_atualiza_entrega_kit : `${API_BASE_URL}/core/inscricoes/entrega_kit/`,
            url_lote: `${API_BASE_URL}/core/inscricoes/lote/`,

        };
    }

    setNovaInscricaoLote(data){
        return fetch(this.state.url_lote, {
            method: 'POST',
            body: typeof data === 'string' ? data : JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    setNovaInscricao(data){
        return fetch(this.state.url, {method:'POST', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    setPreferenciaPagamento(data){
        return fetch(this.state.url2, {method:'POST', body:typeof data === 'string' ? data : JSON.stringify(data),headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    checkoutCartao(data){
        return fetch(this.state.url_checkout_cartao, {method:'POST', body:typeof data === 'string' ? data : JSON.stringify(data),headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    checkoutPix(data){
        return fetch(this.state.url_checkout_pix, {method:'POST', body:typeof data === 'string' ? data : JSON.stringify(data),headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getCheckoutStatus(orderId){
        return fetch(`${this.state.url_checkout_status}${orderId}/`, {method:'GET', headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getInscricaoById(id){
        return fetch(`${this.state.url}${id}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    deleteInscricao(id){
        return fetch(`${this.state.url}${id}/`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    deleteOrderPorCorrida(idCorrida){
        return fetch(`${this.state.url_orders_corrida}${idCorrida}/`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    updateInscricao(data, id){
        return fetch(this.state.url8+id, {method:'PATCH', body:data,headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    aplicarVoucher(inscricaoId, data){
        const bodyData = typeof data === 'string' ? data : JSON.stringify(data);
        const headers = {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
        };
        const baseUrl = API_BASE_URL.replace(/\/+$/, '');
        const endpoints = [
            `${baseUrl}/core/inscricoes/efetiva_inscicao/${inscricaoId}/`,
            `${baseUrl}/core/inscricoes/efetiva_inscicao/${inscricaoId}`,
            `${baseUrl}/core/inscricoes/${inscricaoId}/`,
            `${baseUrl}/core/inscricoes/${inscricaoId}`
        ];

        const tryFetch = async (index = 0) => {
            if (index >= endpoints.length) {
                return fetch(endpoints[0], { method: 'PATCH', body: bodyData, headers });
            }
            try {
                const res = await fetch(endpoints[index], { method: 'PATCH', body: bodyData, headers });
                if (res.ok || res.status === 400) {
                    return res;
                }
                if (res.status === 404 || res.status === 301 || res.status === 405) {
                    return tryFetch(index + 1);
                }
                return res;
            } catch (err) {
                return tryFetch(index + 1);
            }
        };

        return tryFetch(0);
    };

    patchInscricao(id, data){
        const bodyData = typeof data === 'string' ? data : JSON.stringify(data);
        return fetch(`${this.state.url_atualiza_entrega_kit}${id}/`, {
            method: 'PATCH',
            body: bodyData,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    getInscricaoPerCorrida(corridaId, page = 1, pageSize = 15, search = ''){
        let url = `${this.state.url3}${corridaId}/`;
        const params = new URLSearchParams();
        if (page !== undefined && page !== null) params.append('page', page);
        if (pageSize !== undefined && pageSize !== null) params.append('page_size', pageSize);
        if (search) {
            params.append('search', search);
            params.append('nome', search);
            params.append('q', search);
        }

        const queryString = params.toString();
        if (queryString) {
            url += `?${queryString}`;
        }

        return fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    getAllInscricoesPerCorrida(corridaId){
        const url = `${this.state.url3}${corridaId}/?all=true&page_size=100000`;
        return fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };


    geCounttInscricaoPerCorrida(data){
        return fetch(this.state.url4+data, {method:'GET', headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getCountInscricoesPerCorrida(data){
        return this.geCounttInscricaoPerCorrida(data);
    };

    getCounttMeiosPagamentoPerCorrida(data){
        return fetch(this.state.url5+data, {method:'GET', headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getCountMeioPagamentoPerCorrida(data){
        return this.getCounttMeiosPagamentoPerCorrida(data);
    };

    getCountCorridasUsuario(data){
        return fetch(this.state.url6+data, {method:'GET', headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getInscricaoPerUsuario(data){
        return fetch(this.state.url7+data, {method:'GET', headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getMetricaCorredoro(corrida,usuario){
        return fetch(this.state.url_metrica+corrida+'/'+usuario, {method:'GET', headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    setMetricaCorredoro(data){
        return fetch(this.state.url_metricas, {method:'post', body:data,headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getCorridasAtuaisUsuario(usuario){
        return fetch(this.state.url_incricao_usuario_vigente+usuario, {method:'GET', headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getCorridasFinalizadasUsuario(usuario){
        return fetch(this.state.url_incricao_usuario_finalizada+usuario, {method:'GET', headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getCorridasPendentesUsuario(usuario){
        return fetch(this.state.url_incricao_usuario_pendente+usuario, {method:'GET', headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getVouchersPerCorrida(corridaId){
        const baseUrl = API_BASE_URL.replace(/\/+$/, '');
        const headers = {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
        };
        const endpoints = [
            `${baseUrl}/core/inscricoes/vouchers/${corridaId}/`,
            `${baseUrl}/core/inscricoes/vouchers/${corridaId}`,
            `${baseUrl}/core/inscricoes/voucher/${corridaId}/`,
            `${baseUrl}/core/inscricoes/voucher/${corridaId}`,
            `${baseUrl}/core/inscricoes/per_corrida/vouchers/${corridaId}/`,
            `${baseUrl}/core/inscricoes/new_voucher/?id_corrida=${corridaId}`,
            `${baseUrl}/inscricoes/vouchers/${corridaId}/`,
            `${baseUrl}/inscricoes/vouchers/${corridaId}`
        ];

        const tryFetch = async (index = 0) => {
            if (index >= endpoints.length) {
                return fetch(endpoints[0], { method: 'GET', headers });
            }
            try {
                const res = await fetch(endpoints[index], { method: 'GET', headers });
                if (res.ok) {
                    return res;
                }
                if (res.status === 404 || res.status === 301 || res.status === 405) {
                    return tryFetch(index + 1);
                }
                return res;
            } catch (err) {
                return tryFetch(index + 1);
            }
        };

        return tryFetch(0);
    };
}

export default InscricaoService;
